export const HOVER_SHADOW_TRANSITION = "box-shadow 0.3s ease-in-out";
